function isValidHexCode(input: string): boolean {
  // Regex to match a valid hex code with or without opacity
  const hexRegex = /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/;
  return hexRegex.test(input);
}

export default isValidHexCode;
